/* This file is autogenerated, see readme.md for instructions */
import PlusCircleSvgIcon from '@bloomreach/banana-theme/icons/plus-circle.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PlusCircleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PlusCircleSvgIcon />
    </Icon>
  );
});

PlusCircleIcon.displayName = 'PlusCircleIcon';

export default PlusCircleIcon;
